export const dialogTypes = {
  alert: 'alert',
  confirm: 'confirm',
  prompt: 'prompt',
  impersonation: 'impersonation',
  cellComment: 'cellComment',
  newTicket: 'newTicket',
  taskResultEditor: 'taskResultEditor',
  address: 'address',
  codeListEditor: 'codeListEditor',
  institutionGroup: 'institutionGroup',
  relatedInstitution: 'relatedInstitution',
  relatedPerson: 'relatedPerson',
  reportTemplateImport: 'reportTemplateImport',
  license: 'license',
  branch: 'branch',
  realEstate: 'realEstate',
  contactInformation: 'contactInformation',
  personalId: 'personalId',
  ban: 'ban',
  individualInCharge: 'individualInCharge',
  organizationalUnit: 'organizationalUnit',
  jobTitle: 'jobTitle',
  submissionDate: 'submissionDate',
  newReportingCycle: 'newReportingCycle',
  editDocumentationItem: 'editDocumentationItem',
  addDashboardWidget: 'addDashboardWidget',
  institutionSelection: 'institutionSelection',
  addNewAnnouncement: 'addNewAnnouncement',
  userRow: 'userRow',
  bankSelector: 'bankSelector',
  branchSelector: 'branchSelector',
  job: 'job',
  newReportingHolidays: 'newReportingHolidays',
  institution: 'institution',
  institutionPermission: 'institutionPermission',
  individualPermission: 'individualPermission',
  addUserRole: 'addUserRole',
  editInChargeOfInstitutions: 'editInChargeOfInstitutions',
  reportTemplateSelector: 'reportTemplateSelector',
  branchManagers: 'branchManagers',
  addNewReportingGroup: 'addNewReportingGroup',
  editPlainText: 'editPlainText',
  exportPdf: 'exportPdf',
  editCycleParameters: 'editCycleParameters',
  inputPassphrase: 'inputPassphrase',
  inputPatTokenName: 'inputPatTokenName',
  generatedPatToken: 'generatedPatToken',
  capitalOperation: 'capitalOperation',
  course: 'course',
  education: 'education',
  experience: 'experience',
  addIndividualDuplicity: 'addIndividualDuplicity',
  helpPreview: 'helpPreview',
  editPhoneNumber: 'editPhoneNumber',
  addDataCrossingWeight: 'addDataCrossingWeight',
  addDataCrossingAllowedCombination: 'addDataCrossingAllowedCombination',
  problematicCombination: 'problematicCombination',
  twoFactorAuthentication: 'twoFactorAuthentication',
  twoFactorSetup: 'twoFactorSetup',
  addOutputReportGroup: 'addOutputReportGroup',
  bankAccountNumber: 'bankAccountNumber',
  editLegacyCode: 'editLegacyCode',
  blacklistDetail: 'blacklistDetail',
  editCheckingRule: 'editCheckingRule',
  userSelector: 'userSelector',
  selectReportTemplateCategory: 'selectReportTemplateCategory',
  editReportTemplateCategory: 'editReportTemplateCategory',
  reportGroupPermission: 'reportGroupPermission',
  outputReportGroupDefinitionPermissions: 'outputReportGroupDefinitionPermissions',
  bgJobMessages: 'bgJobMessages',
  validationErrors: 'validationErrors',
  addWorkflowVersion: 'addWorkflowVersions',
  editConstantCategory: 'editConstantCategory',
  editConstant: 'editConstant',
  editDimension: 'editDimension',
  editDimensionItem: 'editDimensionItem',
  addColumnBinding: 'addColumnBinding',
  composeNewMessage: 'composeNewMessage',
  viewMessage: 'viewMessage',
  auditLog: 'auditLog',
  setValidRange: 'setValidRange',
  outputReportInstitutions: 'outputReportInstitutions',
  outputReportSources: 'outputReportSources'
}



// WEBPACK FOOTER //
// ./src/dialogs/index.js